import { put, call, select } from "redux-saga/effects";
import { getDistance } from "geolib";
import importer from "common/importer";
const CentersActions = importer("Stores/Centers/Actions");
const { getDonorCentersAll, getCoordinatesForZipcode } = importer(
  "APIs/centers",
  null
);
const { donor } = importer("Stores/Donors/Select", null);
export default function* main({
  searchStr,
  isDIS8Center,
  searchType,
  addNewDonorBonusInformation,
  setCenterDistance,
  isSortByDistanceFalse = false,
}) {
  try {
    yield put(CentersActions.getDonorCentersAllLoading());
    const _donor = yield select(donor);
    let res = yield getDonorCentersAll(
      searchStr,
      isDIS8Center,
      searchType,
      addNewDonorBonusInformation
    );
    res.data = res.data.filter(
      (item) => item.isCenterHiddenFromDonors === null
    );
    if (setCenterDistance && !isSortByDistanceFalse) {
      const geocodeRes = yield call(
        getCoordinatesForZipcode,
        searchStr ?? _donor.data.zipCode
      );
      if (geocodeRes.data?.results.length === 0) {
        yield put(CentersActions.getDonorCentersAllSuccess(res));
        return;
      }
      const givenLocation = {
        latitude: geocodeRes.data?.results[0].geometry.location.lat,
        longitude: geocodeRes.data?.results[0].geometry.location.lng,
      };
      const resDataSortedByDistance = res.data
        ?.map((item) => {
          return {
            ...item,
            distanceFromGivenZipcode: (
              getDistance(givenLocation, {
                latitude: item.latitude,
                longitude: item.longitude,
              }) / 1609.34
            ).toFixed(2),
          };
        })
        .sort(
          (a, b) => a.distanceFromGivenZipcode - b.distanceFromGivenZipcode
        );
      res = { ...res, data: resDataSortedByDistance };
    }
    yield put(CentersActions.getDonorCentersAllSuccess(res));
  } catch (error) {
    yield put(CentersActions.getDonorCentersAllFailure(error));
  }
}
